import { useCallback, useEffect, useState } from 'react'
import { GetP2PIndex } from '../services/peerToPeer/PeerToPeerService'
import { type CollectionIndex } from '../models/peerToPeer/Collection'
import { handleApiResponse } from '../utils/apiHelpers'

interface UseP2PCollectionIndexType {
  index: CollectionIndex | null
  isLoading: boolean
  reload: () => Promise<void>
  /** Refetch without the loading spinner, so a step already on screen stays put. */
  refreshInBackground: () => Promise<void>
}

export const useP2PCollectionIndex = (): UseP2PCollectionIndexType => {
  const [index, setIndex] = useState<CollectionIndex | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const reload = useCallback(async (): Promise<void> => {
    setIsLoading(true)
    setIndex(await handleApiResponse(GetP2PIndex()))
    setIsLoading(false)
  }, [])

  const refreshInBackground = useCallback(async (): Promise<void> => {
    const result = await handleApiResponse(GetP2PIndex())
    if (result != null) setIndex(result)
  }, [])

  useEffect(() => { void reload() }, [reload])

  return { index, isLoading, reload, refreshInBackground }
}
